<app-header></app-header>
<p-toast
	[breakpoints]="{
		'920px': { width: '100%', right: '0', top: '0', left: '0' },
	}"
/>
@if (!!(authService.userData$ | async)?.sessionID) {
	<router-outlet></router-outlet>
} @else {
	<div class="sign-in-content">
		<div>Please sign in.</div>
		<p-button label="Sign in" [disabled]="isProcessingAuthentication()" (onClick)="authService.login()"></p-button>
	</div>
}
<app-main-layout></app-main-layout>
